import { styledMediaClassName } from '../cards/CardMedia/StyledMedia.styled'
import { StyledKicker, StyledKickerText } from '../cards/Kicker/Kicker.styled'
import { playOverlayClassName } from '../content/Video/components/PlayOverlay/PlayOverlay.common'

// Because the video sits inside a Link we need to check to see if the video element,
// interface or play button is clicked in order to ignore the link and hide the kicker
// {TODO} Get rid of overrideHideKickerBehaviorOnPN after Com games and make sure we type the exclude array properly.
export function isVideoClick(
    target: EventTarget | null,
    exclude: string[] = [],
    overrideHideKickerBehaviorOnPN?: boolean,
) {
    if (!(target instanceof HTMLElement)) {
        return false
    }

    const videoTriggerClasses = overrideHideKickerBehaviorOnPN
        ? ['video', 'vjs', styledMediaClassName, playOverlayClassName]
        : [
              'video',
              'vjs',
              styledMediaClassName,
              StyledKicker,
              StyledKickerText,
              playOverlayClassName,
          ]

    const className = target.className
    return (
        new RegExp(videoTriggerClasses.join('|')).test(className) &&
        !exclude.includes(className)
    )
}
